import type { RootState } from "../store";

export const selectSite = (state: RootState) => state.site;
export const selectSiteId = (state: RootState) => state.site?.siteId;

